import { createFileRoute } from "@tanstack/react-router";
import { AboutPage, aboutHeadDa } from "@/pages/AboutPage";

export const Route = createFileRoute("/about")({
  head: aboutHeadDa,
  component: AboutPage,
});
